var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBlackMicActive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mic_Active",
    "data-name": "Mic Active",
    transform: "translate(-2414 -1754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M8.1,6.346a.4.4,0,0,1,.4.4v5.6a.4.4,0,0,1-.8,0v-5.6A.4.4,0,0,1,8.1,6.346Zm-1.6,1.2a.4.4,0,0,1,.4.4v3.2a.4.4,0,0,1-.8,0v-3.2A.4.4,0,0,1,6.5,7.546Zm-1.6.8a.4.4,0,0,1,.4.4v1.6a.4.4,0,0,1-.8,0v-1.6A.4.4,0,0,1,4.9,8.346Z",
    transform: "translate(2409.5 1747.654)",
    fill: "#6d808d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M8.1,6.346a.4.4,0,0,1,.4.4v5.6a.4.4,0,0,1-.8,0v-5.6A.4.4,0,0,1,8.1,6.346Zm-1.6,1.2a.4.4,0,0,1,.4.4v3.2a.4.4,0,0,1-.8,0v-3.2A.4.4,0,0,1,6.5,7.546Zm-1.6.8a.4.4,0,0,1,.4.4v1.6a.4.4,0,0,1-.8,0v-1.6A.4.4,0,0,1,4.9,8.346Z",
    transform: "translate(2438.5 1766.746) rotate(180)",
    fill: "#6d808d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mic",
    transform: "translate(2418 1754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M3.6,6.5a.613.613,0,0,1,.6.625v1.25a4.9,4.9,0,0,0,4.8,5,4.9,4.9,0,0,0,4.8-5V7.125a.6.6,0,1,1,1.2,0v1.25a6.16,6.16,0,0,1-5.4,6.219v2.531h3.6a.626.626,0,0,1,0,1.25H4.8a.626.626,0,0,1,0-1.25H8.4V14.594A6.16,6.16,0,0,1,3,8.375V7.125A.613.613,0,0,1,3.6,6.5Z",
    transform: "translate(-3 1.625)",
    fill: "#0d3148",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M8.6,0A3.677,3.677,0,0,0,5,3.75V10a3.677,3.677,0,0,0,3.6,3.75A3.677,3.677,0,0,0,12.2,10V3.75A3.677,3.677,0,0,0,8.6,0Z",
    transform: "translate(-2.6 0)",
    fill: "#0d3148",
    fillRule: "evenodd"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlackMicActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/black_mic_active.4b4d7745bb16c73460b62e168e4f37a7.svg";